"use client";

import { useEffect } from "react";

/**
 * Последняя линия обороны: ошибка в самом корневом layout. Здесь переводов уже нет
 * (провайдер next-intl мог не смонтироваться), поэтому текст английский и короткий,
 * а телефон продаж виден без всяких зависимостей.
 */
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#F7F6F3",
          color: "#1A1D21",
          fontFamily: "Inter, Helvetica, Arial, sans-serif",
          padding: "24px",
        }}
      >
        <main style={{ maxWidth: "40ch", textAlign: "left" }}>
          <h1 style={{ fontSize: "28px", lineHeight: 1.2, margin: "0 0 12px" }}>
            So Origin Pattaya
          </h1>
          <p style={{ color: "#5A626B", lineHeight: 1.7, margin: "0 0 24px" }}>
            The page could not be displayed. Please try again or call +66 97 906 09 99.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              background: "#2A5560",
              color: "#fff",
              border: 0,
              borderRadius: "3px",
              padding: "14px 20px",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
